<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div class="select-box input_left">
      <Input v-model="searchPluginTitle" style="width:100px;" placeholder="插件名称"/>
    </div>
    <div class="select-box input_left_two">
      <Input v-model="searchPluginCode" style="width:100px;" placeholder="插件包名" />
      <Select v-model="searchStatus" style="width: 100px;margin-left:25px;" placeholder="审核状态">
        <Option :value="0">待审核</Option>
        <Option :value="1">审核通过</Option>
        <Option :value="2">审核驳回</Option>
      </Select>
      <Select v-model="searchPluginType" style="width: 100px;margin-left:25px;" placeholder="插件类型">
        <Option :value="-1">全选</Option>
        <Option :value="0">droidplugin</Option>
        <Option :value="1">virtualApp</Option>
      </Select>
      <Select v-model="searchEnableStatus" style="width: 100px;margin-left:25px;" placeholder="插件状态">
        <Option :value="1">启用</Option>
        <Option :value="0">禁用</Option>
      </Select>
    </div>
    <div class="select-box input_left_four">
      <Button type="primary" @click="newAlert" style="margin-right:10px;">上传APK插件</Button>
      <all-user ref="allUser" @usernameChange="usernameChange"></all-user>
    </div>
    <div class="select-box input_left_three">
      <Button type="primary" @click="searchBtn" style="margin-right:5px;">查询</Button>
      <Button type="primary" @click="searchClear">重置</Button>
    </div>
    <div class="select-box">
      <!-- <Button type="primary" @click="newAlert" style="margin-right:5px;">添加APK插件</Button> -->
    </div>
    <div class="app-list-table">
      <Table :loading="tableLoading" ref="selection" @on-selection-change="tableOnSelect" class="spacingTwice" border :columns="columns" :data="dataList"></Table>
      <Page show-total :total="total" :current="current" :page-size="pageSize"
          @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />
    </div>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="batchErrArrFlag"
      title="信息提示"
      @on-ok="clearErrArr()"
    >
    <div v-for="(item,index) in batchErrArr" :key="index">
      {{item.name}}---{{item.message}}
    </div>
    </Modal>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="plPush"
      title="批量提交审核"
      @on-ok="editDataPL('formValidatePl')"
      >
      <Form ref="formValidatePl" :model="formValidate" :label-width="120">
        <FormItem label="提交审核" prop="name">
          <Input v-model="formValidatePl.ver" placeholder="请输入版本号" />
        </FormItem>
      </Form>
      <div>统计共{{this.tableSelectRow.length}}个应用</div>
    </Modal>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="plPublish"
      title="批量发布"
       @on-ok="editDataPL('formValidatePl')"
      >
      <Form ref="formValidatePl" :model="formValidate" :label-width="120">
        <FormItem label="批量发布" prop="name">
          <Input v-model="formValidatePl.ver" placeholder="请输入版本号" />
        </FormItem>
      </Form>
      <div>统计共{{this.tableSelectRow.length}}个应用</div>
    </Modal>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="plBack"
      title="批量回退"
       @on-ok="editDataPL('formValidatePl')"
      >
      <Form ref="formValidatePl" :model="formValidate" :label-width="120">
        <FormItem label="批量回退" prop="name">
          <Input v-model="formValidatePl.ver" placeholder="请输入版本号" />
        </FormItem>
      </Form>
      <div>统计共{{this.tableSelectRow.length}}个应用</div>
    </Modal>
    <div v-if="newdata">
      <Modal
      width="600"
      :mask-closable="false"
      v-model="newdata"
      :footer-hide="editFlag === 'true'?true:false"
      :title="editId ? editFlag === 'true' ? '查看':'编辑' : '上传APK插件'"
      :loading="loading"
      @on-cancel="closeModal"
      @on-ok="editData('formValidate')">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="指定渠道" prop="channelCode">
          <Select
                :disabled="editId? true: channelCodeFlag"
                v-model="formValidate.channelCode"
                placeholder="请选择指定渠道，保存后不可修改"
                filterable
                >
                <Option v-for="(option, index) in channelList" :value="option.code" :tag="option.code" :key="index">{{option.code}}</Option>
            </Select>
        </FormItem>
        <FormItem label="文件上传" prop="apkPath" v-show="editId?false:formValidate.channelCode">
          <Upload type="file" accept='.apk' ref="upload" :headers="{'token':token}" :before-upload="brforeUpload" :onProgress="fileProgress" :onSuccess="filesuccess" :action="`${baseUrl}/extscreenapi/plugin/hili/esApkPlugin/uploadApkFile?channelCode=${formValidate.channelCode === 'all'? '':formValidate.channelCode}`">
              <Button icon="ios-cloud-upload-outline" :disabled="editId?true:false">上传</Button>
          </Upload>
          <p>{{fileName}}</p>
          <Progress :percent="filePercent" v-show="filePercent > 0" :stroke-width="2" />
          <div style="font-size:12px;">文件格式为apk</div>
        </FormItem>
        <FormItem label="插件类型" prop="pluginType">
          <CheckboxGroup v-model="formValidate.pluginType" @on-change="pluginTypeChange">
            <Checkbox :disabled="editFlag === 'true' ? true : typeFlag" label="droidplugin"></Checkbox>
            <Checkbox :disabled="editFlag === 'true' ? true : typeFlag" label="virtualApp"></Checkbox>
        </CheckboxGroup>
          <p style="color:#c00;" v-show="!typeFlag && editId">请慎重更改，插件类型更改后可能会导致线上插件出错！</p>
        </FormItem>
        <FormItem label="插件状态" v-show="editId?true:false" prop="enableStatus">
          <RadioGroup v-model="formValidate.enableStatus">
            <Radio :disabled="editFlag === 'true'" label="启用"></Radio>
            <Radio :disabled="editFlag === 'true'" label="禁用"></Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="占用大小" prop="useSpace" v-show="editId?false:true">
          <Input v-model="formValidate.useSpace" placeholder="插件解压后的大小，单位MB，如不填写默认100MB">
          <template #append>
              <span>MB</span>
            </template>
          </Input>
          <!-- <p style="color:#c00;">插件解压后的大小，检测磁盘空间是否满足，如不填写默认100M！</p> -->
        </FormItem>
        <FormItem label="更新说明" prop="remarks">
          <Input :disabled="editFlag === 'true'" v-model="formValidate.remarks" placeholder="备注最大字数为50字" maxlength="50" type="textarea" :rows="4" />
        </FormItem>
        <FormItem label="插件名称" prop="pluginTitle">
          <Input v-model="formValidate.pluginTitle" :disabled="true" placeholder="上传apk后自动生成" />
        </FormItem>
        <FormItem label="插件包名" prop="pluginCode">
          <Input v-model="formValidate.pluginCode" :disabled="true" placeholder="上传apk后自动生成" />
        </FormItem>
        <FormItem label="版本名称" prop="pluginVerName" v-show="editId?false:true">
          <Input v-model="formValidate.pluginVerName" :disabled="true" placeholder="上传apk后自动生成" />
        </FormItem>
        <FormItem label="版本号" prop="pluginVerCode" v-show="editId?false:true">
          <Input v-model="formValidate.pluginVerCode" :disabled="true" placeholder="上传apk后自动生成" />
        </FormItem>
        <FormItem label="校验值" prop="md5" v-show="editId?false:true">
          <Input v-model="formValidate.md5" :disabled="'true'" placeholder="上传apk后自动生成" />
        </FormItem>
      </Form>
    </Modal>
    </div>
    <verify-modal ref="verify"></verify-modal>
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb'
import verifyModal from '@/components/global/verifyModal'
import allUser from '@/components/global/allUser'
import https from '../../https'
import Axios from 'axios'
export default {
  name: 'esApp',
  data () {
    return {
      loading: true,
      tableLoading: true,
      newdata: false,
      authorized: false,
      mobileApp: [],
      editId: '',
      editItem: '',
      userList: [],
      userInfoId: '',
      editFlag: 'false',
      searchPluginTitle: '',
      searchPluginCode: '',
      searchStatus: '',
      searchPluginType: '',
      searchEnableStatus: '',
      currentIndex: '',
      isShowSpin: false,
      plType: 0,
      plPush: false,
      plPublish: false,
      plBack: false,
      tableSelectRow: [],
      batchErrArr: [],
      batchErrArrFlag: false,
      baseUrl: '',
      formValidatePl: {
        ver: ''
      },
      formValidate: {
        pluginType: [],
        // storeVerCodes: '',
        enableStatus: '启用',
        channelCode: '',
        pluginTitle: '',
        pluginCode: '',
        pluginVerName: '',
        pluginVerCode: '',
        md5: '',
        remarks: '',
        files: '',
        pluginId: '',
        apkPath: '',
        apkId: ''
      },
      ruleValidate: {
        enableStatus: [{ required: true, message: '请选择启用状态' }],
        channelCode: [{ required: true, message: '请选择渠道' }],
        apkPath: [{ required: false, message: '文件格式为apk' }],
        pluginType: [{ required: true, message: '请选择插件类型' }]
        // cardName: [
        //   { required: true, message: '请输入卡片名称', trigger: 'blur' },
        //   { type: 'string', max: 20, min: 1, message: '请输入2-20个字', trigger: 'blur' }
        // ],
        // apk_pkg: { required: true, pattern: /^[a-zA-Z0-9]+\.[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)*$/g, message: '示例：tv.huan.vibes.test' }
      },
      columns: [ // table表格
        {
          title: '用户名',
          key: 'userName',
          width: 200,
          align: 'center'
        },
        {
          title: '插件名称',
          key: 'pluginTitle',
          width: 200,
          align: 'center'
        },
        {
          title: '插件包名',
          key: 'pluginCode',
          width: 150,
          align: 'center'
        },
        // {
        //   title: '宿主包名',
        //   key: 'pkgName',
        //   align: 'center',
        //   width: 150
        // },
        {
          title: '指定渠道',
          key: 'channelCode',
          align: 'center',
          width: 100,
          render: (h, params) => {
            let status = ''
            if (params.row.channelCode.length > 0) {
              status = params.row.channelCode
            } else {
              status = '全部'
            }
            let html = [
              h('span', status)
            ]
            return html
          }
        },
        {
          title: '审核状态',
          key: 'status',
          align: 'center',
          width: 100,
          render: (h, params) => {
            let status = ''
            switch (params.row.status) {
              case 0:
                status = '待审核'
                break
              case 1:
                status = '审核通过'
                break
              case 2:
                status = '审核驳回'
                break
            }
            let html = [
              h('span', {
                style: {
                  cursor: 'pointer',
                  color: 'blue'
                },
                on: {
                  click: () => {
                    this.$refs.verify.show(params.row, 'apk', 'apk')
                  }
                }
              }, status)
            ]
            return html
          }
        },
        {
          title: '插件类型',
          key: 'pluginType',
          align: 'center',
          width: 150,
          render: (h, params) => {
            let status = ''
            switch (params.row.pluginType) {
              case -1:
                status = 'droidplugin | virtualApp'
                break
              case 0:
                status = 'droidplugin'
                break
              case 1:
                status = 'virtualApp'
                break
            }
            let html = [
              h('span', status)
            ]
            return html
          }
        },
        {
          title: '插件状态',
          key: 'enableStatus',
          align: 'center',
          width: 100,
          render: (h, params) => {
            let status = ''
            switch (params.row.enableStatus) {
              case 0:
                status = '禁用'
                break
              case 1:
                status = '启用'
                break
            }
            let html = [
              h('span', status)
            ]
            return html
          }
        },
        {
          title: '更新说明',
          key: 'remarks',
          align: 'center',
          width: 250
        },
        {
          title: '驳回原因',
          key: 'reason',
          align: 'center',
          width: 200
        },
        {
          title: '创建时间',
          key: 'createTime',
          align: 'center',
          minWidth: 250
        },
        {
          title: '最后更新时间',
          key: 'updateTime',
          align: 'center',
          minWidth: 250,
          render: (h, params) => {
            let status = ''
            if (params.row.updateTime != null) {
              status = params.row.updateTime
            } else {
              status = params.row.createTime
            }
            let html = [
              h('span', status)
            ]
            return html
          }
        },
        {
          title: '操作',
          width: 320,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: (params.row.status === 0 || params.row.createBy !== this.userId)
                },
                style: {
                  width: '50px',
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.newAlert(params.index, 'edit')
                  }
                }
              }, '编辑'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  width: '50px',
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.newAlert(params.index, 'look')
                  }
                }
              }, '查看'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  width: '70px',
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.$router.push({
                      path: `/developer/versionApk`,
                      query: {
                        pluginTitle: params.row.pluginTitle,
                        id: params.row.id,
                        status: params.row.status
                      }
                    })
                  }
                }
              }, '版本管理')
            ])
          }
        }
      ],
      channelList: [],
      mobileData: {
        id: '',
        name: '',
        app_rel: []
      },
      appPkgFlag: false,
      dataSource: [], // table数据源
      tvpList: [],
      dataList: [], // tab当前页数据
      total: 0, // tab总条数
      pageSize: 10, // 每页多少条
      current: 1, // 当前页
      t1: 0,
      t2: 0,
      timer: null,
      userId: '',
      token: null,
      channelCodeFlag: false,
      isNew: false,
      typeFlag: true,
      fileformat: ['apk'],
      fileName: null,
      filePercent: 0,
      uploadModal: false,
      errorModal: false,
      cancelUpload: {
        cancel: null
      },
      searchName: ''
    }
  },
  components: {
    breadcrumb,
    verifyModal,
    allUser
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.token = https.token
    this.baseUrl = process.env.API_HOST
    this.userId = localStorage.getItem('userId')
    this.loadData()
  },
  mounted () {
  },
  methods: {
    pluginTypeChange () {
      if (!this.editId) {
        return
      }
      this.$Modal.confirm({
        title: '温馨提示',
        cancelText: ' ',
        content: '<p class="del-modal-txt">插件类型更改后可能会导致线上插件出错, <span></span> 请慎重更改！</p>',
        onOk: () => {
        }
      })
    },
    brforeUpload (file) {
      this.fileAjaxUpload(file)
      return false
      // let main = this.$refs.upload
      // if (main.fileList && main.fileList.length) {
      //   main.fileList.forEach(item => {
      //     main.clearFiles()
      //   })
      // }
    },
    fileAjaxUpload (file) {
      let that = this
      this.fileName = file.name
      let index1 = file.name.lastIndexOf('.')
      let index2 = file.name.length
      let fileSuffix = file.name.substring(index1 + 1, index2).toLowerCase()
      if (this.fileformat.indexOf(fileSuffix) === -1) {
        this.$Message.error('文件格式不正确,请上传apk格式文件')
        return false
      }
      let fd = new FormData()
      fd.append('file', file)
      const CancelToken = Axios.CancelToken
      https.requestUpload({
        url: this.baseUrl + '/extscreenapi/plugin/hili/esApkPlugin/uploadApkFile?channelCode=' + (this.formValidate.channelCode === 'all' ? '' : this.formValidate.channelCode),
        method: 'post',
        data: fd,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        cancelToken: new CancelToken(function executor (c) {
          that.cancelUpload.cancel = c
        }),
        onUploadProgress: (progressEvent) => { // 上传进度事件
          console.log(progressEvent)
          if (progressEvent) {
            that.filePercent = Number((progressEvent.loaded / progressEvent.total * 100).toFixed(2))
          }
        }
      }).then(res => {
        console.log('成功')
        this.filesuccess(res)
      }).catch(error => {
        this.filePercent = 0
        this.fileName = ''
        console.log('失败', error)
      })
    },
    clearData () {
      this.formValidate.pluginTitle = ''
      this.formValidate.pluginCode = ''
      this.formValidate.pluginVerName = ''
      this.formValidate.pluginVerCode = ''
      this.formValidate.md5 = ''
      this.formValidate.pluginId = ''
      this.formValidate.apkId = ''
      this.fileName = ''
    },
    fileProgress () {
      this.clearData()
    },
    filesuccess (e) {
      if (e.code === 500) {
        this.$Message.error('上传zip包失败，请重新上传')
      } else if (e.code === 400) {
        this.clearData()
        this.channelCodeFlag = false
        this.$Message.error(e.message)
        this.brforeUpload()
      } else {
        this.formValidate.pluginTitle = e.result.pluginTitle
        this.formValidate.pluginCode = e.result.pluginCode
        this.formValidate.pluginId = e.result.pluginId
        this.formValidate.apkId = e.result.apkId
        this.formValidate.pluginVerName = e.result.pluginVerName
        this.formValidate.pluginVerCode = e.result.pluginVerCode
        this.formValidate.md5 = e.result.md5
        this.formValidate.apkPath = e.result.apkPath
        this.channelCodeFlag = true
        this.isNew = e.result.new
        let type = []
        if (e.result.pluginType === null) {
          type = []
          this.typeFlag = false
        } else if (e.result.pluginType === -1) {
          type = ['droidplugin', 'virtualApp']
        } else if (e.result.pluginType === 0) {
          type = ['droidplugin']
        } else if (e.result.pluginType === 1) {
          type = ['virtualApp']
        }
        this.formValidate.pluginType = type
      }
    },
    closeModal () {
      this.channelCodeFlag = false
      this.typeFlag = true
      this.fileName = ''
      if (this.cancelUpload.cancel) {
        this.filePercent = 0
        this.cancelUpload.cancel()
      }
      this.$refs['formValidate'].resetFields()
    },
    getChannels () {
      https.request({
        method: 'get',
        url: '/v2/es/channels',
        params: {
          page_size: 100
        }
      }).then(res => {
        let first = {
          name: '全部',
          code: 'all'
        }
        this.channelList = res.data.items || []
        this.channelList.unshift(first)
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    tableOnSelect (row) {
      this.tableSelectRow = row
    },
    changePlType () {
      if (this.plType === '1') {
        console.log('批量提交')
        this.plPush = true
      } else if (this.plType === '2') {
        console.log('批量发布')
        this.plPublish = true
      } else if (this.plType === '3') {
        console.log('批量版本回退')
        this.plBack = true
      }
    },
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      this.loadData()
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.loadData()
    },
    searchBtn () {
      this.loadData()
    },
    searchClear () {
      this.searchPluginTitle = ''
      this.searchPluginCode = ''
      this.searchStatus = ''
      this.searchPluginType = ''
      this.searchEnableStatus = ''
      this.searchName = ''
      this.$refs.allUser.clear()
      this.loadData()
    },
    aduitText (val) {
      if (val === 0) {
        return '未提审'
      } else if (val === 1) {
        return '待审核'
      } else if (val === 2) {
        return '审核通过'
      } else if (val === 3) {
        return '审核驳回'
      }
    },
    usernameChange (val) {
      this.searchName = val
      this.loadData()
    },
    // 加载tabs列表
    loadData (id = '') {
      let params = {
        column: 'updateTime',
        order: 'desc',
        pageSize: this.pageSize,
        pageNo: this.current,
        pluginTitle: `*${this.searchPluginTitle}*`,
        pluginCode: this.searchPluginCode,
        status: this.searchStatus,
        pluginType: this.searchPluginType,
        enableStatus: this.searchEnableStatus,
        createBy: this.searchName
      }
      this.isShowSpin = true
      https.request({
        method: 'get',
        // url: 'extscreenapi/plugin/hili/cardGroup/list',
        url: 'extscreenapi/plugin/hili/esApkPlugin/list',
        params: params
      }).then(res => {
        console.log(res)
        this.tableLoading = false
        this.isShowSpin = false
        // this.dataList = res.result.records
        this.getUserNameFun(res.result.records)
        this.formValidate = {
          pluginType: [],
          enableStatus: '启用',
          channelCode: '',
          pluginTitle: '',
          pluginCode: '',
          pluginVerName: '',
          pluginVerCode: '',
          md5: '',
          remarks: '',
          files: '',
          pluginId: '',
          apkPath: '',
          apkId: ''
        }
        this.total = res.result.total
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    getUserNameFun (list) {
      let arr = []
      list.map(item => {
        arr.push(item.createBy)
      })
      let str = arr.join(',')
      https.request({
        method: 'get',
        url: `getUsernamesByIds?ids=${str}`,
        params: {}
      }).then(res => {
        res.data.map(item => {
          list.map(sItem => {
            if (item.value === sItem.createBy) {
              sItem['userName'] = item.text
            }
          })
        })
        this.dataList = list
      })
    },
    newAlert (index, atype = 'edit') {
      // this.$refs['formValidate'].resetFields()
      this.getChannels()
      if (!isNaN(index)) {
        let type = []
        console.log(this.dataList[index].pluginType)
        if (this.dataList[index].pluginType === -1) {
          type = ['droidplugin', 'virtualApp']
        } else if (this.dataList[index].pluginType === 0) {
          type = ['droidplugin']
        } else if (this.dataList[index].pluginType === 1) {
          type = ['virtualApp']
        }
        this.formValidate = {
          pluginTitle: this.dataList[index].pluginTitle,
          pluginCode: this.dataList[index].pluginCode,
          pluginType: [...type],
          useSpace: this.dataList[index].useSpace ? this.dataList[index].useSpace / 1024 / 1024 : '',
          enableStatus: this.dataList[index].enableStatus === 0 ? '禁用' : '启用',
          channelCode: this.dataList[index].channelCode.length === 0 ? 'all' : this.dataList[index].channelCode,
          remarks: this.dataList[index].remarks,
          // storeVerCodes: this.dataList[index].storeVerCodes,
          pluginVerName: this.dataList[index].pluginVerName,
          pluginVerCode: this.dataList[index].pluginVerCode,
          md5: this.dataList[index].md5,
          pluginId: this.dataList[index].pluginId,
          apkId: this.dataList[index].apkId,
          apkPath: '00'
        }
        this.editFlag = this.dataList[index].createBy === this.userId ? atype === 'edit' ? 'false' : 'true' : 'true'
        this.editId = this.dataList[index].id
        this.currentIndex = index
        this.typeFlag = false
      } else {
        this.editId = ''
        this.formValidate.useSpace = ''
        this.editFlag = false
      }
      this.newdata = true
    },
    editDataPL (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          if (this.tableSelectRow.length === 0) {
            this.plType = '0'
            this.$Message.error('请先选择应用')
            this.tableSelectRow = []
            return
          }
          let arr = []
          this.tableSelectRow.map(item => {
            arr.push(item.id)
          })
          let params = new FormData()
          params.append('ver', this.formValidatePl.ver)
          params.append('type', this.plType)
          params.append('ids', arr)
          https.request({
            method: 'put',
            url: '/v2/es/app/vers/batch',
            data: params
          }).then(res => {
            this.formValidatePl.ver = ''
            this.plType = 0
            this.tableSelectRow = []
            this.loadData()
            let errArr = []
            res.data.map(item => {
              if (item.status !== 1) {
                console.log(item)
                this.dataList.map(dItem => {
                  if (dItem.id === item.id) {
                    errArr.push({
                      name: dItem.name,
                      message: item.message
                    })
                  }
                })
              }
            })
            this.batchErrArr = errArr
            if (errArr.length > 0) {
              this.batchErrArrFlag = true
            }
          }).catch(error => {
            this.$Message.error(error)
          })
        }
      })
    },
    clearErrArr () {
      this.batchErrArrFlag = false
      this.batchErrArr = []
    },
    editData (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.changeLoading()
            if (this.formValidate.apkPath.length === 0) {
              this.$Message.error('请上传apk插件')
              return
            }
            let type = -1
            if (this.formValidate.pluginType.length === 2) {
              type = -1
            } else if (this.formValidate.pluginType[0] === 'droidplugin') {
              type = 0
            } else if (this.formValidate.pluginType[0] === 'virtualApp') {
              type = 1
            }
            let params = {
              remarks: this.formValidate.remarks,
              useSpace: this.formValidate.useSpace === '' || this.formValidate.useSpace === null ? '104857600' : this.formValidate.useSpace * 1024 * 1024,
              pluginType: type,
              enableStatus: this.formValidate.enableStatus === '启用' ? 1 : 0,
              pluginId: this.formValidate.pluginId,
              apkId: this.formValidate.apkId
            }
            console.log(this.editId)
            if (this.editId) {
              params['id'] = this.editId
              https.request({
                method: 'put',
                url: 'extscreenapi/plugin/hili/esApkPlugin/edit',
                data: params
              }).then(res => {
                console.log(res)
                if (res.code === 400) {
                  console.log(res.message)
                  this.$Message.error(res.message)
                  this.newdata = false
                  this.loadData()
                  return
                }
                if (res.code === 500) {
                  this.$Message.error('名称重复')
                  return
                }
                this.$Message.success('提交成功')
                this.newdata = false
                this.loadData()
              }).catch(error => {
                this.$Message.error(error)
              })
            } else {
              this.channelCodeFlag = false
              if (this.isNew) {
                this.$Modal.confirm({
                  title: '温馨提示',
                  content: '<p class="del-modal-txt">检测到没有该包名的插件，是否要创建该插件？</p>',
                  onOk: () => {
                    https.request({
                      method: 'put',
                      url: 'extscreenapi/plugin/hili/esApkPlugin/editUpload',
                      data: params
                    }).then(res => {
                      if (res.code === 500) {
                        this.$Message.error(res.message)
                        return
                      } else if (res.code === 400) {
                        this.$Message.error(res.message)
                        return
                      }
                      this.$Message.success('提交成功')
                      this.newdata = false
                      this.loadData()
                    }).catch(error => {
                      this.$Message.error(error)
                    })
                  }
                })
              } else {
                https.request({
                  method: 'put',
                  url: 'extscreenapi/plugin/hili/esApkPlugin/editUpload',
                  data: params
                }).then(res => {
                  console.log(res)
                  if (res.code === 500) {
                    this.$Message.error(res.message)
                    return
                  } else if (res.code === 400) {
                    this.$Message.error(res.message)
                    return
                  }
                  this.$Message.success('提交成功')
                  this.newdata = false
                  this.loadData()
                }).catch(error => {
                  this.$Message.error(error)
                })
              }
            }
          }, 1000)
        } else {
          this.changeLoading()
        }
      })
    },
    // delItem (index) {
    //   this.$Modal.confirm({
    //     title: '提示',
    //     content: '<p class="del-modal-txt">确定要删除 <span>' + this.dataList[index].cardName + '</span> 吗？</p>',
    //     onOk: () => {
    //       https.request({
    //         method: 'GET',
    //         url: '/v1/tvp/del',
    //         params: {
    //           id: this.dataList[index].cardId
    //         }
    //       }).then(res => {
    //         this.$Message.success('删除成功')
    //         if (this.dataList.length === 1 && this.current > 1) this.current -= 1
    //         this.loadData()
    //       }).catch(error => {
    //         this.$Message.error(error)
    //       })
    //     }
    //   })
    // },
    changeLoading () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .container{
    position: relative;
  }
  .file-wrap {
    position: relative;
    display: inline-block;
    margin-bottom: 10px;
    .file-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .env-btn {
    display: flex;
    justify-content: space-between;
    button {
      width: 140px;
    }
  }
  .select-box{
    display: flex;
    position: absolute;
    top: 20px;
    right: 140px;
    .select-label{
      line-height: 32px;
      margin-right: 10px;
    }
  }
  .select-box-type{
    display: flex;
    position: absolute;
    top: 20px;
    right: 60px;
  }
  .select-box-type-pl{
    display: flex;
    position: absolute;
    top: 20px;
    right: 260px;
  }
  .input_left{
    left:140px;
    // left:407px;
  }
  .input_left_two{
    left:266px;
    // left:580px;
  }
  .input_left_four{
    left:139px;
    top:60px;
  }
  .input_left_three{
    left:761px;
    // left:755px;
  }
  .app_aduit_stats{
    position: absolute;
    top:0px;
    right:0px;
  }
  .app_close_stats{
    position: absolute;
    top:0px;
    left:4px;
  }
  .app-list-table{
    padding:53px 0;
  }
  .agreement_title{
    text-align: center;
    font-size:20px;
    font-weight: bold;
  }
  .agreement_text{
    width:700px;
    // border:1px solid #000;
    height:500px;
    overflow-y: auto;
    margin-left:50px;
  }
  #copyinput{
    position: absolute;
    bottom: -30px;
  }
  .card-spin-container{
        display: inline-block;
        width: 100%;
        height: 100%;
        // position: relative;
    }
  .del-modal-txt{
    color:#c00;
  }
</style>



// WEBPACK FOOTER //
// src/components/esApk/esApk.vue